"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
const PAGE_BREAKPOINT = '760px';
exports.StyledPage = styled_1.default.div `
	display: block;
	max-width: ${theme_1.default.layout.container.maxWidth};
	margin: auto;

	@media only screen and (min-width: ${PAGE_BREAKPOINT}) {
		display: flex;
		justify-content: space-between;
	}
`;
exports.StyledPageContent = styled_1.default.div `
	flex-grow: 1;
	display: flex;
	flex-direction: column;

	@media only screen and (min-width: ${PAGE_BREAKPOINT}) {
		${(props) => props.size === 'narrow' ? 'max-width: 66%;' : ''}
	}

	.page-content__container {
		width: 100%;
	}
`;
exports.StyledPageSubContent = styled_1.default.div `
	margin-top: ${theme_1.default.spacing.default};
	width: 100%;
	display: flex;
	flex-direction: column;

	@media only screen and (min-width: ${PAGE_BREAKPOINT}) {
		margin: 0;
		width: 33%;
		margin-left: ${theme_1.default.spacing.default};
	}
`;
//# sourceMappingURL=page.styled.js.map